import { render } from "./cta.vue?vue&type=template&id=09507e08&scoped=true"
import script from "./cta.vue?vue&type=script&lang=js"
export * from "./cta.vue?vue&type=script&lang=js"

import "./cta.vue?vue&type=style&index=0&id=09507e08&lang=sass&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09507e08"]])

export default __exports__